/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BannerProductsResponse,
    CategoryRowLiveStreamsResponse,
    CategoryRowSellersResponse,
    CategoryRowShowsResponse,
    CategoryRowUpcomingShowsResponse,
    CategoryRowsDetailCountResponse,
    CategoryRowsResponse,
    DiscoveryCategoryEventsResponse,
    DiscoveryFeaturedEventsResponse,
    DiscoveryShowResponse,
    DiscoveryShowsByEventResponse,
    DiscoveryStoreListingItem,
    DiscoveryUnBundleEventsResponse,
    LiveShowsByEventIdResponse,
    LiveShowsResponse,
    NewToPopshopLiveResponse,
    OurPicksForYouResponse,
    PageProductsResponse,
    RecentlyAddedShowsResponse,
    StoreList,
    TopCategoryRowsResponse,
    TopReviewsResponse,
} from '../models';

export interface DiscoveryApiControllerGetCategoryRowLiveStreamsRequest {
    categoryDiscoveryRowId: string;
}

export interface DiscoveryApiControllerGetCategoryRowSellersRequest {
    categoryDiscoveryRowId: string;
}

export interface DiscoveryApiControllerGetCategoryRowShowsRequest {
    categoryDiscoveryRowId: string;
}

export interface DiscoveryApiControllerGetCategoryRowUpcomingShowsRequest {
    categoryDiscoveryRowId: string;
}

export interface DiscoveryApiControllerGetCategoryRowsDetailCountRequest {
    categoryRowIds: Array<string>;
}

export interface DiscoveryApiControllerGetDiscoveryRowShowsRequest {
    categoryRowId?: string;
    eventId?: string;
    excludeDiscoveryShows?: boolean;
}

export interface DiscoveryApiControllerGetDiscoveryShowsRequest {
    eventId?: string;
}

export interface DiscoveryApiControllerGetFeaturedListingsRequest {
    categoryRowId?: string;
}

export interface DiscoveryApiControllerGetLiveShowsRequest {
    categoryRowId?: string;
}

export interface DiscoveryApiControllerGetLiveShowsByEventIdRequest {
    eventId: string;
}

export interface DiscoveryApiControllerGetShowsByUnBundleEventIdRequest {
    eventId: string;
}

export interface DiscoveryApiControllerNewToPopshopLiveRequest {
    categoryRowId?: string;
}

export interface DiscoveryApiControllerNewToPopshopLiveV2Request {
    categoryRowId?: string;
    pageNo?: number;
    pageSize?: number;
}

export interface DiscoveryApiControllerNewToPopshopLiveV3Request {
    categoryRowId?: string;
    cursor?: string;
    pageSize?: number;
}

export interface DiscoveryApiControllerOurPicksForYouRequest {
    categoryRowId?: string;
    eventId?: string;
    limit?: number;
}

export interface DiscoveryApiControllerShowBannerProductsRequest {
    eventId?: string;
}

export interface DiscoveryApiControllerShowPageProductsRequest {
    pageNo: number;
    pageSize: number;
    eventId?: string;
}

export interface DiscoveryApiControllerTopReviewsRowRequest {
    categoryRowId?: string;
}

/**
 * 
 */
export class DiscoveryApi extends runtime.BaseAPI {

    /**
     * Public API
     */
    async discoveryApiControllerGetCategoryEventsRaw(): Promise<runtime.ApiResponse<DiscoveryCategoryEventsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/category-events`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetCategoryEvents(): Promise<DiscoveryCategoryEventsResponse> {
        const response = await this.discoveryApiControllerGetCategoryEventsRaw();
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetCategoryRowLiveStreamsRaw(requestParameters: DiscoveryApiControllerGetCategoryRowLiveStreamsRequest): Promise<runtime.ApiResponse<CategoryRowLiveStreamsResponse>> {
        if (requestParameters.categoryDiscoveryRowId === null || requestParameters.categoryDiscoveryRowId === undefined) {
            throw new runtime.RequiredError('categoryDiscoveryRowId','Required parameter requestParameters.categoryDiscoveryRowId was null or undefined when calling discoveryApiControllerGetCategoryRowLiveStreams.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/category-rows/{categoryDiscoveryRowId}/liveStreams`.replace(`{${"categoryDiscoveryRowId"}}`, encodeURIComponent(String(requestParameters.categoryDiscoveryRowId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetCategoryRowLiveStreams(requestParameters: DiscoveryApiControllerGetCategoryRowLiveStreamsRequest): Promise<CategoryRowLiveStreamsResponse> {
        const response = await this.discoveryApiControllerGetCategoryRowLiveStreamsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetCategoryRowSellersRaw(requestParameters: DiscoveryApiControllerGetCategoryRowSellersRequest): Promise<runtime.ApiResponse<CategoryRowSellersResponse>> {
        if (requestParameters.categoryDiscoveryRowId === null || requestParameters.categoryDiscoveryRowId === undefined) {
            throw new runtime.RequiredError('categoryDiscoveryRowId','Required parameter requestParameters.categoryDiscoveryRowId was null or undefined when calling discoveryApiControllerGetCategoryRowSellers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/category-rows/{categoryDiscoveryRowId}/sellers`.replace(`{${"categoryDiscoveryRowId"}}`, encodeURIComponent(String(requestParameters.categoryDiscoveryRowId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetCategoryRowSellers(requestParameters: DiscoveryApiControllerGetCategoryRowSellersRequest): Promise<CategoryRowSellersResponse> {
        const response = await this.discoveryApiControllerGetCategoryRowSellersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetCategoryRowShowsRaw(requestParameters: DiscoveryApiControllerGetCategoryRowShowsRequest): Promise<runtime.ApiResponse<CategoryRowShowsResponse>> {
        if (requestParameters.categoryDiscoveryRowId === null || requestParameters.categoryDiscoveryRowId === undefined) {
            throw new runtime.RequiredError('categoryDiscoveryRowId','Required parameter requestParameters.categoryDiscoveryRowId was null or undefined when calling discoveryApiControllerGetCategoryRowShows.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/category-rows/{categoryDiscoveryRowId}/shows`.replace(`{${"categoryDiscoveryRowId"}}`, encodeURIComponent(String(requestParameters.categoryDiscoveryRowId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetCategoryRowShows(requestParameters: DiscoveryApiControllerGetCategoryRowShowsRequest): Promise<CategoryRowShowsResponse> {
        const response = await this.discoveryApiControllerGetCategoryRowShowsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetCategoryRowUpcomingShowsRaw(requestParameters: DiscoveryApiControllerGetCategoryRowUpcomingShowsRequest): Promise<runtime.ApiResponse<CategoryRowUpcomingShowsResponse>> {
        if (requestParameters.categoryDiscoveryRowId === null || requestParameters.categoryDiscoveryRowId === undefined) {
            throw new runtime.RequiredError('categoryDiscoveryRowId','Required parameter requestParameters.categoryDiscoveryRowId was null or undefined when calling discoveryApiControllerGetCategoryRowUpcomingShows.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/category-rows/{categoryDiscoveryRowId}/upcomingShows`.replace(`{${"categoryDiscoveryRowId"}}`, encodeURIComponent(String(requestParameters.categoryDiscoveryRowId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetCategoryRowUpcomingShows(requestParameters: DiscoveryApiControllerGetCategoryRowUpcomingShowsRequest): Promise<CategoryRowUpcomingShowsResponse> {
        const response = await this.discoveryApiControllerGetCategoryRowUpcomingShowsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetCategoryRowsRaw(): Promise<runtime.ApiResponse<CategoryRowsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/category-rows`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetCategoryRows(): Promise<CategoryRowsResponse> {
        const response = await this.discoveryApiControllerGetCategoryRowsRaw();
        return await response.value();
    }

    /**
     */
    async discoveryApiControllerGetCategoryRowsDetailCountRaw(requestParameters: DiscoveryApiControllerGetCategoryRowsDetailCountRequest): Promise<runtime.ApiResponse<CategoryRowsDetailCountResponse>> {
        if (requestParameters.categoryRowIds === null || requestParameters.categoryRowIds === undefined) {
            throw new runtime.RequiredError('categoryRowIds','Required parameter requestParameters.categoryRowIds was null or undefined when calling discoveryApiControllerGetCategoryRowsDetailCount.');
        }

        const queryParameters: any = {};

        if (requestParameters.categoryRowIds) {
            queryParameters['categoryRowIds'] = requestParameters.categoryRowIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/category-rows:detailCount`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async discoveryApiControllerGetCategoryRowsDetailCount(requestParameters: DiscoveryApiControllerGetCategoryRowsDetailCountRequest): Promise<CategoryRowsDetailCountResponse> {
        const response = await this.discoveryApiControllerGetCategoryRowsDetailCountRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetDiscoveryFeaturedEventsRaw(): Promise<runtime.ApiResponse<DiscoveryFeaturedEventsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/featured-events`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetDiscoveryFeaturedEvents(): Promise<DiscoveryFeaturedEventsResponse> {
        const response = await this.discoveryApiControllerGetDiscoveryFeaturedEventsRaw();
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetDiscoveryRowShowsRaw(requestParameters: DiscoveryApiControllerGetDiscoveryRowShowsRequest): Promise<runtime.ApiResponse<DiscoveryShowResponse>> {
        const queryParameters: any = {};

        if (requestParameters.categoryRowId !== undefined) {
            queryParameters['categoryRowId'] = requestParameters.categoryRowId;
        }

        if (requestParameters.eventId !== undefined) {
            queryParameters['eventId'] = requestParameters.eventId;
        }

        if (requestParameters.excludeDiscoveryShows !== undefined) {
            queryParameters['excludeDiscoveryShows'] = requestParameters.excludeDiscoveryShows;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/discovery-row-shows`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetDiscoveryRowShows(requestParameters: DiscoveryApiControllerGetDiscoveryRowShowsRequest): Promise<DiscoveryShowResponse> {
        const response = await this.discoveryApiControllerGetDiscoveryRowShowsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetDiscoveryShowsRaw(requestParameters: DiscoveryApiControllerGetDiscoveryShowsRequest): Promise<runtime.ApiResponse<DiscoveryShowResponse>> {
        const queryParameters: any = {};

        if (requestParameters.eventId !== undefined) {
            queryParameters['eventId'] = requestParameters.eventId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/shows`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetDiscoveryShows(requestParameters: DiscoveryApiControllerGetDiscoveryShowsRequest): Promise<DiscoveryShowResponse> {
        const response = await this.discoveryApiControllerGetDiscoveryShowsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetFeaturedListingsRaw(requestParameters: DiscoveryApiControllerGetFeaturedListingsRequest): Promise<runtime.ApiResponse<Array<DiscoveryStoreListingItem>>> {
        const queryParameters: any = {};

        if (requestParameters.categoryRowId !== undefined) {
            queryParameters['categoryRowId'] = requestParameters.categoryRowId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/featured-listings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetFeaturedListings(requestParameters: DiscoveryApiControllerGetFeaturedListingsRequest): Promise<Array<DiscoveryStoreListingItem>> {
        const response = await this.discoveryApiControllerGetFeaturedListingsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetLiveShowsRaw(requestParameters: DiscoveryApiControllerGetLiveShowsRequest): Promise<runtime.ApiResponse<LiveShowsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.categoryRowId !== undefined) {
            queryParameters['categoryRowId'] = requestParameters.categoryRowId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/live-shows`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetLiveShows(requestParameters: DiscoveryApiControllerGetLiveShowsRequest): Promise<LiveShowsResponse> {
        const response = await this.discoveryApiControllerGetLiveShowsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetLiveShowsByEventIdRaw(requestParameters: DiscoveryApiControllerGetLiveShowsByEventIdRequest): Promise<runtime.ApiResponse<LiveShowsByEventIdResponse>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling discoveryApiControllerGetLiveShowsByEventId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/events/{eventId}/live-shows`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetLiveShowsByEventId(requestParameters: DiscoveryApiControllerGetLiveShowsByEventIdRequest): Promise<LiveShowsByEventIdResponse> {
        const response = await this.discoveryApiControllerGetLiveShowsByEventIdRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetRecentlyAddedShowsRaw(): Promise<runtime.ApiResponse<RecentlyAddedShowsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/recently-added-shows`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetRecentlyAddedShows(): Promise<RecentlyAddedShowsResponse> {
        const response = await this.discoveryApiControllerGetRecentlyAddedShowsRaw();
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetShowsByUnBundleEventIdRaw(requestParameters: DiscoveryApiControllerGetShowsByUnBundleEventIdRequest): Promise<runtime.ApiResponse<DiscoveryShowsByEventResponse>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling discoveryApiControllerGetShowsByUnBundleEventId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/events/{eventId}/shows`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetShowsByUnBundleEventId(requestParameters: DiscoveryApiControllerGetShowsByUnBundleEventIdRequest): Promise<DiscoveryShowsByEventResponse> {
        const response = await this.discoveryApiControllerGetShowsByUnBundleEventIdRaw(requestParameters);
        return await response.value();
    }

    /**
     * Andy told me(Harry) app uses /v1/discovery/category-rows
     * Public API
     */
    async discoveryApiControllerGetTopCategoryRowsRaw(): Promise<runtime.ApiResponse<TopCategoryRowsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/discovery/category-rows`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Andy told me(Harry) app uses /v1/discovery/category-rows
     * Public API
     */
    async discoveryApiControllerGetTopCategoryRows(): Promise<TopCategoryRowsResponse> {
        const response = await this.discoveryApiControllerGetTopCategoryRowsRaw();
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetUnBundleEventsRaw(): Promise<runtime.ApiResponse<DiscoveryUnBundleEventsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/un-bundle-events`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerGetUnBundleEvents(): Promise<DiscoveryUnBundleEventsResponse> {
        const response = await this.discoveryApiControllerGetUnBundleEventsRaw();
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerNewToPopshopLiveRaw(requestParameters: DiscoveryApiControllerNewToPopshopLiveRequest): Promise<runtime.ApiResponse<NewToPopshopLiveResponse>> {
        const queryParameters: any = {};

        if (requestParameters.categoryRowId !== undefined) {
            queryParameters['categoryRowId'] = requestParameters.categoryRowId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/new-to-popshop-live`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerNewToPopshopLive(requestParameters: DiscoveryApiControllerNewToPopshopLiveRequest): Promise<NewToPopshopLiveResponse> {
        const response = await this.discoveryApiControllerNewToPopshopLiveRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerNewToPopshopLiveV2Raw(requestParameters: DiscoveryApiControllerNewToPopshopLiveV2Request): Promise<runtime.ApiResponse<StoreList>> {
        const queryParameters: any = {};

        if (requestParameters.categoryRowId !== undefined) {
            queryParameters['categoryRowId'] = requestParameters.categoryRowId;
        }

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/discovery/new-to-popshop-live`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerNewToPopshopLiveV2(requestParameters: DiscoveryApiControllerNewToPopshopLiveV2Request): Promise<StoreList> {
        const response = await this.discoveryApiControllerNewToPopshopLiveV2Raw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerNewToPopshopLiveV3Raw(requestParameters: DiscoveryApiControllerNewToPopshopLiveV3Request): Promise<runtime.ApiResponse<StoreList>> {
        const queryParameters: any = {};

        if (requestParameters.categoryRowId !== undefined) {
            queryParameters['categoryRowId'] = requestParameters.categoryRowId;
        }

        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/discovery/new-to-popshop-live`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerNewToPopshopLiveV3(requestParameters: DiscoveryApiControllerNewToPopshopLiveV3Request): Promise<StoreList> {
        const response = await this.discoveryApiControllerNewToPopshopLiveV3Raw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerOurPicksForYouRaw(requestParameters: DiscoveryApiControllerOurPicksForYouRequest): Promise<runtime.ApiResponse<OurPicksForYouResponse>> {
        const queryParameters: any = {};

        if (requestParameters.categoryRowId !== undefined) {
            queryParameters['categoryRowId'] = requestParameters.categoryRowId;
        }

        if (requestParameters.eventId !== undefined) {
            queryParameters['eventId'] = requestParameters.eventId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/our-picks-for-you`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerOurPicksForYou(requestParameters: DiscoveryApiControllerOurPicksForYouRequest): Promise<OurPicksForYouResponse> {
        const response = await this.discoveryApiControllerOurPicksForYouRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerShowBannerProductsRaw(requestParameters: DiscoveryApiControllerShowBannerProductsRequest): Promise<runtime.ApiResponse<BannerProductsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.eventId !== undefined) {
            queryParameters['eventId'] = requestParameters.eventId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/banner-products`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerShowBannerProducts(requestParameters: DiscoveryApiControllerShowBannerProductsRequest): Promise<BannerProductsResponse> {
        const response = await this.discoveryApiControllerShowBannerProductsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerShowPageProductsRaw(requestParameters: DiscoveryApiControllerShowPageProductsRequest): Promise<runtime.ApiResponse<PageProductsResponse>> {
        if (requestParameters.pageNo === null || requestParameters.pageNo === undefined) {
            throw new runtime.RequiredError('pageNo','Required parameter requestParameters.pageNo was null or undefined when calling discoveryApiControllerShowPageProducts.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling discoveryApiControllerShowPageProducts.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageNo !== undefined) {
            queryParameters['pageNo'] = requestParameters.pageNo;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.eventId !== undefined) {
            queryParameters['eventId'] = requestParameters.eventId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/page-products`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerShowPageProducts(requestParameters: DiscoveryApiControllerShowPageProductsRequest): Promise<PageProductsResponse> {
        const response = await this.discoveryApiControllerShowPageProductsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerTopReviewsPageRaw(): Promise<runtime.ApiResponse<TopReviewsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/top-reviews-page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerTopReviewsPage(): Promise<TopReviewsResponse> {
        const response = await this.discoveryApiControllerTopReviewsPageRaw();
        return await response.value();
    }

    /**
     * Public API
     */
    async discoveryApiControllerTopReviewsRowRaw(requestParameters: DiscoveryApiControllerTopReviewsRowRequest): Promise<runtime.ApiResponse<TopReviewsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.categoryRowId !== undefined) {
            queryParameters['categoryRowId'] = requestParameters.categoryRowId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/discovery/top-reviews-row`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async discoveryApiControllerTopReviewsRow(requestParameters: DiscoveryApiControllerTopReviewsRowRequest): Promise<TopReviewsResponse> {
        const response = await this.discoveryApiControllerTopReviewsRowRaw(requestParameters);
        return await response.value();
    }

}
